import { CommentsoldIntegrationProduct } from "@redotech/redo-model/commentsold";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const createCommentsoldIntegration = {
  name: "createCommentsoldIntegration" as const,
  input: z.object({
    product: createEnum(CommentsoldIntegrationProduct),
    shop: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
